import { cancel, publishSelected } from 'reactApp/modules/integration/integration.actions';
import { handleCancel } from 'reactApp/modules/integration/sagas/cancel.saga';
import { handlePublishSelected } from 'reactApp/modules/integration/sagas/publishSelected.saga';
import { takeEvery } from 'redux-saga/effects';

export function* watchIntegration() {
    yield takeEvery(publishSelected.toString(), handlePublishSelected);
    yield takeEvery(cancel.toString(), handleCancel);
}
